import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import type { TemplatesTableSchemaDivisionMail } from '../tables';
import { schemaTemplatesDivisionMail } from '../tables';

type Arguments = {
    divisionId: string;
    status: TemplatesTableSchemaDivisionMail['data']['assignedStatus'];
};

export const schemaTemplateResolver_GetDivisionMailByDivisionAndStatus = schemaTemplatesDivisionMail.nullable();

export type SchemaTemplateResolver_GetDivisionMailByDivisionAndStatus = z.infer<
    typeof schemaTemplateResolver_GetDivisionMailByDivisionAndStatus
>;

export type TemplateResolver_GetDivisionMailByDivisionAndStatus = Resolver<
    Arguments,
    SchemaTemplateResolver_GetDivisionMailByDivisionAndStatus
>;
